module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Forte_Vento_Laterale.e9081b37.svg";